import React from 'react';
import CardsGrid from "../CardsGrid";
import Grid from "../Grid";
import Card from "../Card";
import Container from "../Container";
import IconRotate from '../../public/images/rotate.svg';
import IconSplit from '../../public/images/split.svg';
import IconCompress from '../../public/images/compress.svg';
import {useTranslation} from "next-i18next";

const GridEditPdf = () => {
  const { t } = useTranslation(['common', 'index', 'edit-pdf']);

  return (
    <Container className="mt-xs-3 mb-xs-3 mb-md-4">
      <h3>{t('index:other.title')}</h3>
      <CardsGrid>
        <Grid.Item>
          <Card
            href="/rotate-pdf"
            title={t('common:cards.rotate.title')}
            text={t('common:cards.rotate.text')}
            size='md'
            icon={IconRotate}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/split-pdf"
            title={t('common:cards.split.title')}
            text={t('common:cards.split.text')}
            size='md'
            icon={IconSplit}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/compress-pdf"
            title={t('common:cards.compress.title')}
            text={t('common:cards.compress.text')}
            size='md'
            icon={IconCompress}
          />
        </Grid.Item>
      </CardsGrid>
    </Container>
  );
};

export default GridEditPdf;
